import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMESTAMP_MULTIPLY, TIMEOUT_STORE, ZERO, TIME} from 'util/constants';


const getDate = unixDate => {

    const date = new Date(unixDate * TIMESTAMP_MULTIPLY);
    const diff = date.getTimezoneOffset() / TIME.MINUTES;

    if (diff > ZERO) {
        date.setHours(date.getHours() + diff);
    } else if (diff < ZERO) {
        date.setHours(date.getHours() + diff);
    }


    return date.getTime();
};

const
    name = 'spendingLastYear',
    exports = storeModuleFactory({
        name,
        endpoint:            endpoints.spendingLastYear.endpoint,
        timeout:             TIMEOUT_STORE.TIMEOUT_STORE_MEDIUM,
        transformEntitiesFn: item => ({
            ...item,
            data: item.data.map(itemData => ({
                ...itemData,
                month: getDate(itemData.month)
            }))
        })
    });


module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/spendingLastYear.js